import React, { ReactElement } from "react";
import { BackToLogin, LoginLayout } from "Components";

type PasswordResetLayoutProps = {
  children: ReactElement | ReactElement[];
};

const PasswordResetLayout = ({
  children,
}: PasswordResetLayoutProps): React.JSX.Element => {
  return (
    <LoginLayout>
      <>
        {children}
        <BackToLogin />
      </>
    </LoginLayout>
  );
};

export default PasswordResetLayout;
